var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleShap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176,
    height: 183,
    viewBox: "0 0 176 183",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.9259 0C47.884 0 16.0072 22.1442 1.78122 53.9333C-1.7966 61.9251 0.169172 71.4063 6.79693 77.1203C8.85169 78.8861 10.5003 81.0764 11.6297 83.5405C12.759 86.0046 13.3423 88.6843 13.3394 91.3955C13.3421 94.0741 12.7726 96.7222 11.669 99.1622C10.5655 101.602 8.95334 103.778 6.94088 105.543C3.73378 108.372 1.51775 112.157 0.618451 116.341C-0.28085 120.524 0.184014 124.887 1.94474 128.787C16.3004 160.487 48.2431 182.503 85.3027 182.35C136.371 182.14 177.094 140.236 175.964 89.116C174.876 39.7133 134.534 0 84.9259 0Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleShap);
export default __webpack_public_path__ + "static/media/CircleShap.fda49dca80ad74f176c99c9885adfe7d.svg";
export { ForwardRef as ReactComponent };